import detectLang from '@global/helpers/detectLang';
import Cookies from 'js-cookie';
import gtmTrace from '@global/components/tracing/gtm';
import AlertDialog from '@global/helpers/alertDialog';
import $ from 'jquery';
import { fireViewCart, fireRemoveFromCart } from '@global/gtm/checkoutGTM/cart';

import axios from 'axios';

const cartModule = {
  namespaced: true,
  state: {
    addOnEvents: [],
    cartTotal: 0,
    can_paytype: true,
    can_delivery: true,
    cartTotalWithoutAddon: 0,
    detectLang: detectLang(),
    dataIsLoad: false,
    giftEvents: [],
    hasPreOrder: false,
    isEmployee: false,
    IsOffshoreIsland: true, // 是否可以離島運送
    memo: {
      DeliveryMemo: {
        Message: '',
        AlertMessage: '',
        CanUseDelivery: [],
        AllDelivery: [],
      },
      PayMemo: {
        Message: '',
        CanUsePay: [],
        AllPayType: [],
        CanUseFasneyInstallmentPlan: [],
      },
      SortOutMemo: {
        Message: '',
      },
      AddOnEventMemo: {
        Message: '',
      },
      RewardPointsMemo: {
        Message: '',
        RewardDescription: '',
      },
      FaPointsMemo: {
        IsBound: false,
        PointsBalance: 0.0,
        CanUse: false,
        Threshold: 1000,
        PointsAvailable: 0.0,
        Message: '',
        FaPointsDescription: '',
        AddFaPoints: 0.0,
      },
    },
    shoppingData: [],
    specialCoupon: '',
    selfCouponMessage: '',
    userSelect: {
      region: 1,
      province: '',
      payType: 1,
      deliveryType: 1,
      coupon: '',
      account: '',
      autoPickCoupon: 0,
      basket: 1,
      points: -1,
      faPoints: -1,
      rebate: 0,
      virtualCurrency: 0,
    },
    addonBasket: 1,
    cvsCode: window.cvsCode ? window.cvsCode : '',
    cvsName: window.cvsName ? window.cvsName : '',
    cvsAddress: window.cvsAddress ? window.cvsAddress : '',
    lockBtn: false,
    isCalling: true,
    isForeign: false,
    showRecommendItems: false,
    isFriend: false,
    generalCount: 0, // 常溫總數量
    refrigerationCount: 0, // 冷藏總數量
    freezingCount: 0, // 冷凍總數量
    temperature: 0, // 溫層 0:常溫 1:冷藏 2 冷凍
    generalSpotGoodsCount: 0, // 一般常溫現貨數量
    refrigerationSpotGoodsCount: 0, // 冷藏現貨數量
    freezingSpotGoodsCount: 0, // 冷凍現貨數量
    isCartActive: true,
    recommendID: '',
    nextBuyData: [],
    nextBuyPage: 2,
    nextBuyTotal: 0,
    nextBuyDataIsLoad: false,
    selectedInstallmentPlan: 1, // 使用者分期期數
    canUseFaPoints: true,
    myCoupon: [],
    couponDescription: {},
    activePayEvents: [],
    familyEvent: {},
    payTypeOrder: [1, 3, 7, 9, 2, 5, 4],
    isCh: detectLang() === 'tw' || detectLang() === 'cn',
    cartCurrency: '',
  },
  mutations: {
    changeUserSelect(state, userSelectPayload) {
      const { userSelectKey, userSelectValue } = userSelectPayload;
      state.userSelect[userSelectKey] = userSelectValue;
    },
    /**
     * @description 改變使用者基本資料
     */
    changeUserInfo(state, userInfo) {
      const { userInfoKey, userInfoValue } = userInfo;
      state[userInfoKey] = userInfoValue;
    },
    /**
     * @description 購物車初始化資料(拿取上筆訂單資訊)
     */
    initCartInfo(state) {
      state.userSelect.region = window.shipRegionType !== '0' ? parseInt(window.shipRegionType) : 1;
      state.userSelect.payType = window.payType !== '0' ? parseInt(window.payType) : 1;
      state.userSelect.deliveryType =
        window.deliveryType !== '0' ? parseInt(window.deliveryType) : 1;
      state.userSelect.province = window.provinceType !== '0' ? parseInt(window.provinceType) : '';
      state.selectedInstallmentPlan = window.installmentPlan ? parseInt(window.installmentPlan) : 1;
      state.userSelect.points = window.points ? parseInt(window.points) : -1;
      state.userSelect.faPoints = window.fapoints ? parseInt(window.fapoints) : -1;
      state.userSelect.rebate = window.rebate ? parseInt(window.rebate) : 0;
      state.userSelect.virtualCurrency = window.vc ? parseInt(window.vc) : 0;
    },
    /**
     * @description 購物車初始化購物藍
     */
    initCartTab(state) {
      const urlString = window.location.href;
      const temp = new URL(urlString).searchParams.get('temp');

      if (temp) {
        state.temperature = parseInt(window.temperature);
        state.userSelect.basket = parseInt(window.basket);

        // 超商取貨頁面回來時
        Cookies.set('basket', state.userSelect.basket);
        Cookies.set('temperature', state.temperature);
      } else if (Cookies.get('basket') === undefined) {
        // 使用者不指定溫層且第一次進入購物車畫面，由後端寫入最後一次加入購物車的溫層
        state.temperature = parseInt(window.temperature);
        state.userSelect.basket = parseInt(window.basket);

        Cookies.set('basket', parseInt(window.basket));
        Cookies.set('temperature', parseInt(window.temperature));
      } else {
        // 便利商店畫面與加價購畫面 reload 時
        state.userSelect.basket = parseInt(Cookies.get('basket'));
        state.temperature = parseInt(Cookies.get('temperature'));
      }
    },
    changeTemperature(state, temperature) {
      // 切換溫層後 coupon 機制需更新回預設狀態
      Cookies.remove('coupon');
      Cookies.set('autocoupon', 1);
      state.userSelect.autoPickCoupon = 1;
      state.userSelect.coupon = '';
      state.specialCoupon = '';
      state.selfCouponMessage = '';

      // 推薦商品隱藏
      state.showRecommendItems = false;

      // 使用者購物車購物籃
      if (temperature === 1) {
        // 一般常溫
        state.temperature = 0;
        state.userSelect.basket = 1;
      } else if (temperature === 3) {
        // 冷藏配送
        state.temperature = 1;
        state.userSelect.basket = 3;
      } else {
        // 冷凍配送
        state.temperature = 2;
        state.userSelect.basket = 5;
      }

      // reload page
      Cookies.set('basket', state.userSelect.basket);
      Cookies.set('temperature', state.temperature);
    },
    changeCartTotalCount(state, itemArray) {
      // 溫層ID (0: 常溫，1: 冷藏，2: 常溫)
      itemArray.data.Response.Temperatures.forEach((item) => {
        if (item.ID === 0) {
          state.generalCount = item.Count;
          state.generalSpotGoodsCount = item.InstockCount;
        } else if (item.ID === 1) {
          state.refrigerationCount = item.Count;
          state.refrigerationSpotGoodsCount = item.InstockCount;
        } else {
          state.freezingCount = item.Count;
          state.freezingSpotGoodsCount = item.InstockCount;
        }
      });
    },
    /**
     * @description 檢查是否可使用點數
     */
    checkIfCanUsePoints(state, memo) {
      if (memo.RewardPointsMemo?.Message && $('[data-name="alert-soldout"]').length === 0) {
        AlertDialog.alert(memo.RewardPointsMemo?.Message, undefined, 'alert-soldout');
      }

      if (memo.FaPointsMemo?.Message && $('[data-name="alert-soldout"]').length === 0) {
        AlertDialog.alert(memo.FaPointsMemo?.Message, undefined, 'alert-soldout');
        state.userSelect.faPoints = memo.FaPointsMemo?.PointsAvailable;
      }

      if (memo.RebateMemo?.Message && $('[data-name="alert-soldout"]').length === 0) {
        AlertDialog.alert(memo.RebateMemo?.Message, undefined, 'alert-soldout');
        state.userSelect.rebate = memo.RebateMemo?.Balance;
      }

      if (memo.VirtualCurrencyMemo?.Message && $('[data-name="alert-soldout"]').length === 0) {
        AlertDialog.alert(memo.VirtualCurrencyMemo?.Message, undefined, 'alert-soldout');
        state.userSelect.virtualCurrency = memo.VirtualCurrencyMemo?.Balance;
      }
    },
    /**
     * @description 檢查是否售完
     */
    checkIfSoldOut(state, memo) {
      if (memo.SortOutMemo.Message && $('[data-name="alert-soldout"]').length === 0) {
        AlertDialog.alert(memo.SortOutMemo.Message, undefined, 'alert-soldout');
      }

      if (memo.AddOnEventMemo.Message && $('[data-name="alert-soldout"]').length === 0) {
        AlertDialog.alert(memo.AddOnEventMemo.Message, undefined, 'alert-soldout');
      }
    },
    checkIsEmployee(state) {
      if (state.memo.UserLevelMemo === null) return;
      if (state.memo.UserLevelMemo.Name === '員工') {
        window.isEmployee = true;
        state.isEmployee = true;
        state.userSelect.deliveryType = 5;
      } else {
        window.isEmployee = false;
        state.isEmployee = false;
      }

      if (state.memo.UserLevelMemo.Name === '親友團') {
        state.isFriend = true;
        window.isFriend = true;
      }
    },
    checkCoupon(state, couponMemo) {
      state.specialCoupon = '';
      // user 改變過 Coupon 但 response 回應無此 Coupon 時
      if (state.userSelect.coupon !== '') {
        if (couponMemo.Code === null) {
          AlertDialog.alert(couponMemo.Message);
          state.userSelect.coupon = '';
          Cookies.remove('coupon');
        }
      }

      if (couponMemo.Description !== null) {
        state.selfCouponMessage = couponMemo.Description;
      } else {
        state.selfCouponMessage = '';
      }

      // 自動帶入折價券
      if (couponMemo.Code !== null && state.userSelect.coupon.length === 0) {
        state.specialCoupon = couponMemo.Code;
        Cookies.set('autocoupon', 1);
      }
    },
    /**
     * @description 檢查付款方式可否使用
     * @param { Object } data
     * @param { Array } data.CanUsePay 可用的付款方式
     */
    checkPay(state, data) {
      state.can_paytype = false;
      data.CanUsePay.forEach((element) => {
        if (element === state.userSelect.payType) {
          state.can_paytype = true;
        }
      });
    },
    checkIfAllowIsland(state, payload) {
      const { data, giftData } = payload;
      state.IsOffshoreIsland = true;
      for (const el of data) {
        if (typeof el.IsOffshoreIsland !== 'undefined' && !el.IsOffshoreIsland) {
          state.IsOffshoreIsland = false;
          break;
        }
      }
      for (const el of giftData) {
        if (typeof el.IsOffshoreIsland !== 'undefined' && !el.IsOffshoreIsland) {
          state.IsOffshoreIsland = false;
          break;
        }
      }
    },
    checkIfHasPreOrder(state, marketDatas) {
      state.hasPreOrder = false;
      marketDatas.forEach((element) => {
        if (element.PreOrder) {
          state.hasPreOrder = true;
        }
      });
    },
    toLockBtn(state, bool) {
      state.lockBtn = bool;
    },
    setShoppingCartData(state, shoppingCartData) {
      // 刷新購物車列表
      state.shoppingData = shoppingCartData.ShoppingCart.Markets;
      // 刷新贈品列表
      state.giftEvents = shoppingCartData.ShoppingCart.GiftEvents;
      // 刷新加價購列表
      state.addOnEvents = shoppingCartData.ShoppingCart.AddOnEvents;
      // 刷新tab商品數量
      state.cartTotal = shoppingCartData.ShoppingCart.Count;
      // 刷新tab商品數量
      state.cartTotalWithoutAddon = shoppingCartData.ShoppingCart.MarketCount;
      // 多一個溫層變數，讓不同溫層同樣商品數量再打一次加價購api
      state.addonBasket = state.userSelect.basket;
      // 刷新memo
      state.memo = shoppingCartData.Memo;
      state.cartCurrency = shoppingCartData.CurrentCurrency;
    },
    changeCSVCode(state) {
      state.cvsCode = '';
      state.cvsName = '';
      state.cvsAddress = '';
    },
    addNextBuyTotal(state) {
      state.nextBuyTotal += 1;
    },
    changeNextBuyDate(state, index) {
      state.nextBuyData.splice(index, 1);
      state.nextBuyTotal -= 1;
    },
    async changePayEvent(state) {
      function generateVersionNumber() {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const date = String(now.getDate()).padStart(2, '0');
        const hour = String(now.getHours()).padStart(2, '0');

        return `${year}${month}${date}${hour}`;
      }

      const versionNumber = generateVersionNumber();
      let loadJson = '';

      if (window.PictureContainer.indexOf('-t') !== -1) {
        loadJson = `https://static.tpx.tw/sff-t/common/json/familyMemo.json?v=${versionNumber}`;
      } else {
        loadJson = `https://static.tpx.tw/sff/common/json/familyMemo.json?v=${versionNumber}`;
      }

      let familyMemo = [];
      const now = Date.now();

      try {
        const res = await axios.get(loadJson);
        familyMemo = res.data.Response;
        familyMemo.forEach((element) => {
          const startTime = new Date(element.StartDate).getTime();
          const endTime = new Date(element.EndDate).getTime();
          if (now >= startTime && now <= endTime) {
            state.familyEvent = element;
          }
        });
      } catch (err) {
        console.log(err);
      }

      const fasneyMemo = [
        {
          ID: '9-1',
          ChineseName: 'fasney後支付',
          StartDate: new Date(2023, 11, 18, 0, 0, 0),
          EndDate: new Date(2024, 0, 14, 23, 59, 59),
          Text: '即日起~113/1/14 新戶享首筆訂單95折',
          Href: 'https://www.fasney.com/news/december-event.html',
        },
        {
          ID: '9-12',
          ChineseName: 'fasney分期付',
          StartDate: new Date(2023, 11, 12, 0, 0, 0),
          EndDate: new Date(2023, 11, 17, 23, 59, 59),
          Text: '即日起~12/31 分期筆筆享1% fa points',
          Href: 'https://www.fasney.com/news/normal-event.html',
        },
        {
          ID: '9-12',
          ChineseName: 'fasney分期付',
          StartDate: new Date(2023, 11, 18, 0, 0, 0),
          EndDate: new Date(2024, 0, 14, 23, 59, 59),
          Text: '即日起~113/1/14 分期享1% fa points 新戶再享首筆訂單95折',
          Href: 'https://www.fasney.com/news/all.html',
        },
      ];

      const newDate = new Date().getTime();

      // fasney活動
      const filterEvents = [];
      fasneyMemo.forEach((event) => {
        if (newDate >= event.StartDate.getTime() && newDate <= event.EndDate.getTime()) {
          filterEvents.push({ ID: event.ID, Text: event.Text, Href: event.Href });
        }
      });
      state.activePayEvents = filterEvents;
    },
    setUserCoupon(state, coupons) {
      state.myCoupon = coupons;

      if (state.myCoupon.length) {
        if (state.specialCoupon) {
          state.couponDescription = state.myCoupon.find(
            (element) => element.Code === state.specialCoupon,
          );
        } else {
          state.couponDescription = state.myCoupon.find(
            (element) => element.Code === state.userSelect.coupon,
          );
        }
      }
    },
    clearCouponDescription(state) {
      state.couponDescription = {};
    },
  },
  actions: {
    getShoppingData({ state, dispatch, getters }, userSelect) {
      state.dataIsLoad = false;
      state.isCartActive = true;

      axios
        .get(API_URL.SHOPPING_CART, {
          params: {
            ShippingRegion: userSelect.region,
            Province: userSelect.province,
            PayType: userSelect.payType,
            DeliveryType: userSelect.deliveryType,
            Coupon: userSelect.coupon,
            SortOut: 1,
            AutoPickCoupon: userSelect.autoPickCoupon,
            Basket: userSelect.basket,
            Points: userSelect.points,
            FAPoints: userSelect.faPoints,
            Rebate: userSelect.rebate,
            VirtualCurrency: userSelect.virtualCurrency,
          },
        })
        .then((res) => {
          const language = state.detectLang === 'tw' ? 'zh-tw' : 'en-us';

          if (res.data.Code === 200) {
            if (res.data.Response.ShoppingCart.Markets.length === 0) {
              // 當使用者刪除商品，若該溫層內沒有其它預購或現貨商品時，
              // 則刷新頁面，並走後端 window 值，跳到有商品的那個溫層

              Cookies.remove('basket');
              Cookies.remove('temperature');

              // 冷藏與冷凍商品數量為 0 時，需要自動換頁
              // 若留在原頁面，user 沒有一般常溫 tab 可選
              if (state.temperature === 1 || state.temperature === 2) {
                window.location.href = `/${language}/checkout`;
              }
            }

            dispatch('showShoppingList', res.data);
          } else if (res.data.Code === 205) {
            dispatch('showShoppingList', res.data);

            AlertDialog.special(
              state.isCh
                ? '<div>提醒您，此贈品不提供海外配送將自動移除!</div><div class="mt-4"><a class="btn-close-alert btn btn-secondary btn-block" href="#">取消贈品</a></div>'
                : // eslint-disable-next-line max-len
                  '<div>Remind you that this gift is not provided for overseas shipping and will be automatically removed!</div><div class="mt-4"><a class="btn-close-alert btn btn-secondary btn-block" href="#">Cancel gift</a></div>',
            );
          } else if (res.data.Code === 206) {
            dispatch('showShoppingList', res.data);
            AlertDialog.alert(
              state.isCh
                ? '贈品庫存異動，請重新確認購物車!'
                : 'Gift inventory changes, please reconfirm your shopping cart',
            );
          } else {
            AlertDialog.alert(state.isCh ? '系統忙線中' : 'The server is currently busy');
          }

          // 推薦商品
          if (res.data.Code !== 400 && !state.showRecommendItems) {
            if (res.data.Response.ShoppingCart.Markets.length === 0) {
              state.recommendID = '';
            } else {
              state.recommendID = res.data.Response.ShoppingCart.Markets[0].CustomMarketID;
              state.showRecommendItems = true;
            }
          }
        })
        .then(() => {
          fireViewCart(getters.getGTMData);
        })
        .catch((error) => {
          AlertDialog.alert(state.isCh ? '系統忙線中' : 'The server is currently busy');
          console.log(error);
        });
    },
    updateShoppingData({ state, dispatch }, updateDate) {
      const { id, count, item, isGift } = updateDate;

      axios
        .put(API_URL.SHOPPING_CART, {
          CustomMarketID: id,
          Count: count,
        })
        .then((res) => {
          if (res.data.Code === 200) {
            dispatch('miniCartModule/getCartInfo', null, { root: true });
            dispatch('getShoppingData', state.userSelect);

            if (count === 0 && isGift === undefined) {
              // 幣別
              if (window.PictureContainer.includes('squarebear')) {
                // 目前公版沒這一段
                gtmTrace.removeFromCart({
                  name: item.Name,
                  id,
                  price: item.OriginPrice_TW,
                  sale_price: item.SellPrice_TW,
                  img_url: item.Cover,
                  product_url: item.Url,
                  color: item.Pattern === 2 ? item.Series.FlavorName : item.ColorName,
                  count,
                });

                fireRemoveFromCart({
                  barCode: item.BarCode,
                  clickProductName: item.Name,
                  color: item.Pattern === 2 ? item.Series.FlavorName : item.ColorName,
                  customMarketID: item.CustomMarketID,
                  price: item.SellPrice_TW,
                  quantity: item.Count,
                  size: item.Pattern === 2 ? item.Series.SpecName : item.Size,
                  subtotal: item.Subtotal_TW,
                });
              } else {
                // 目前公版沒這一段
                gtmTrace.removeFromCart({
                  name: item.Name,
                  id,
                  price: item.OriginPrice,
                  sale_price: item.SellPrice,
                  img_url: item.Cover,
                  product_url: item.Url,
                  color: item.Pattern === 2 ? item.Series.FlavorName : item.ColorName,
                  count,
                });

                fireRemoveFromCart({
                  barCode: item.BarCode,
                  clickProductName: item.Name,
                  color: item.Pattern === 2 ? item.Series.FlavorName : item.ColorName,
                  customMarketID: item.CustomMarketID,
                  price: item.SellPrice,
                  quantity: item.Count,
                  size: item.Pattern === 2 ? item.Series.SpecName : item.Size,
                  subtotal: item.Subtotal,
                });
              }
            }

            if (count > 0 && item) {
              gtmTrace.checkout({
                name: item.Name,
                id,
                price: item.OriginPrice,
                sale_price: item.SellPrice,
                img_url: item.Cover,
                product_url: item.Url,
                color: item.Pattern === 2 ? item.Series.FlavorName : item.ColorName,
                count,
              });
            }
          } else {
            AlertDialog.alert(state.isCh ? '系統忙線中' : 'The server is currently busy');
          }
        })
        .catch((error) => {
          AlertDialog.alert(state.isCh ? '系統忙線中' : 'The server is currently busy');
          console.log(error);
        });
    },
    showShoppingList({ state, commit }, res) {
      commit('checkIfSoldOut', res.Response.Memo);
      commit('checkIfCanUsePoints', res.Response.Memo);
      commit('setShoppingCartData', res.Response);
      commit('checkIsEmployee');
      commit('checkCoupon', res.Response.Memo.CouponMemo);
      commit('checkPay', res.Response.Memo.PayMemo);
      // 判斷是否有不允許離島配送商品
      commit('checkIfAllowIsland', {
        data: res.Response.ShoppingCart.Markets,
        giftData: res.Response.ShoppingCart.GiftEvents,
      });
      // 檢查購物車是否有預購商品
      commit('checkIfHasPreOrder', res.Response.ShoppingCart.Markets);
      state.dataIsLoad = true;
      commit('toLockBtn', false);
      state.isCalling = false;
    },
    getNextBuyData({ state }, page) {
      state.isCartActive = false;

      const nowPage = page === 'loadmore' ? state.nextBuyPage : page;

      if (state.nextBuyTotal < state.nextBuyData.length) return;

      axios
        .get(API_URL.FAVORITE, {
          params: {
            Page: nowPage,
            PageSize: 20,
            Basket: state.userSelect.basket,
          },
        })
        .then((res) => {
          if (res.data.Code === 200) {
            if (nowPage === 1) {
              state.nextBuyData = res.data.Response.Data;
            } else {
              state.nextBuyData = state.nextBuyData.concat(res.data.Response.Data);

              if (state.nextBuyPage < res.data.Response.PageCount) {
                state.nextBuyPage += 1;
              }
            }
            // 刷新tab商品數量
            state.nextBuyTotal = res.data.Response.TotalCount;

            // load data complete
            state.nextBuyDataIsLoad = true;
          } else {
            AlertDialog.alert(state.isCh ? '系統忙線中' : 'The server is currently busy');
          }
        })
        .catch((error) => {
          AlertDialog.alert(state.isCh ? '系統忙線中' : 'The server is currently busy');
          console.log(error);
        });
    },
    getCoupon({ state, commit }) {
      const shoppingCartItems = [];

      state.shoppingData.forEach((ele) => {
        const endIndex = ele.CustomMarketID.indexOf('CL');
        const marketID = ele.CustomMarketID.slice(4, endIndex);

        shoppingCartItems.push({
          MarketID: marketID,
          SellPrice: ele.SellPrice,
          Count: ele.Count,
        });
      });

      return new Promise((resolve, reject) => {
        axios
          .post(API_URL.COUPON, {
            ShoppingCartItems: shoppingCartItems,
          })
          .then((res) => {
            if (res.data.Code === 200) {
              commit('setUserCoupon', res.data.Response);
              resolve();
            } else if (res.data.Code === 401) {
              AlertDialog.alert(state.isCh ? '請先登入' : 'Please login first');
              reject();
            } else {
              AlertDialog.alert(state.isCh ? '系統忙線中' : 'The server is currently busy');
              reject();
            }
          })
          .catch((error) => {
            console.log('coupon');
            reject(error);
          });
      });
    },
  },
  getters: {
    userSelectedPayType(state) {
      return state.userSelect.payType;
    },
    userSelectedRegion(state) {
      return state.userSelect.region;
    },
    userSelectedDeliveryType(state) {
      return state.userSelect.deliveryType;
    },
    userSelectedProvince(state) {
      return state.userSelect.province;
    },
    userSelectedPoints(state) {
      return state.userSelect.points;
    },
    userSelectedRebate(state) {
      return state.userSelect.rebate;
    },
    userSelectedVirtualCurrency(state) {
      return state.userSelect.virtualCurrency;
    },
    userSelectedFaPoints(state) {
      if (state.memo.FaPointsMemo.IsBound) {
        if (state.memo.FaPointsMemo.CanUse) {
          if (state.userSelect.faPoints === -1) {
            // 第一次進來使用最大點數
            state.canUseFaPoints = true;
            return state.memo.FaPointsMemo.PointsAvailable;
          }
          if (state.canUseFaPoints === false) {
            // 不可以使用點數到可以使用點數，預設帶入最大點數
            state.canUseFaPoints = true;
            return state.memo.FaPointsMemo.PointsAvailable;
          }
          // 回傳使用者自己輸入的使用點數
          return state.userSelect.faPoints;
        }
        // 不可使用 Fa Points 0 點
        state.canUseFaPoints = false;
        return 0;
      }
      // 未綁定使用 Fa Points 0 點
      return 0;
    },
    getGTMData(state, getters) {
      const coupon = state.specialCoupon ? state.specialCoupon : state.userSelect.coupon;

      return {
        coupon,
        countryCode: state.userSelect.region,
        provinceCode: state.userSelect.province,
        payTypeCode: state.userSelect.payType,
        deliveryCode: state.userSelect.deliveryType,
        cvsCode: state.cvsCode,
        cvsName: state.cvsName,
        cvsAddress: state.cvsAddress,
        memo: state.memo,
        basket: state.userSelect.basket,
        shoppingData: state.shoppingData,
        pPoint: getters.userSelectedPoints,
        faPoint: getters.userSelectedFaPoints,
        addonData: state.addOnEvents.length > 0 ? state.addOnEvents : [],
        gitData: state.giftEvents.length > 0 ? state.giftEvents : [],
      };
    },
  },
};

export default cartModule;
